import { PayloadAction } from '@reduxjs/toolkit';

import { PriceFieldChangedParams } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { onUnitCostChange } from '../calculations/recalculate/on-unit-cost-change';
import { validateUnitCost } from '../validations/unit-cost';

export function unitCostChanged(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<PriceFieldChangedParams>,
) {
  const { value, quoteLineUuid, quotePriceUuid } = action.payload;

  const unitCost = validateUnitCost(state, {
    unitCost: value,
    quoteLineUuid,
    quotePriceUuid,
  });

  if (!unitCost) {
    return;
  }

  onUnitCostChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    unitCost,
  });
}
